export enum RoundingVariants {
  UP = 'UP',
  DOWN = 'DOWN'
}
